import { Box, Grid } from '@mui/material';
import { TextField, DatePicker } from 'mui-rff';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Field } from 'react-final-form';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';

import { Typography } from '@components/styledComponents';

import { DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT } from '../../../../payment-orchestration.constants';

export default function DetailsForm({
  isEditMode = false,
  values,
  validators,
  setValue,
}) {
  return (
    <Box>
      <Typography
        className="form-header"
        variant="formHeader">
        Details
      </Typography>
      <Grid
        container
        spacing={2}>
        <Grid
          item
          xs={3}>
          <Field
            name="details.type"
            validate={validators.required}>
            {({ input: { name, value, onChange } }) => (
              <TextField
                {...{ name, value, onChange }}
                required
                label="Type"
                type="text"
                disabled={isEditMode}
                InputProps={{
                  readOnly: isEditMode,
                  inputProps: { min: 0 },
                }}
              />
            )}
          </Field>
        </Grid>
        <Grid
          item
          xs={3}>
          <Field
            name="details.subType"
            validate={validators.required}>
            {({ input: { name, value, onChange } }) => (
              <TextField
                {...{ name, value, onChange }}
                required
                label="Sub Type"
                type="text"
                disabled={isEditMode}
                InputProps={{
                  readOnly: isEditMode,
                  inputProps: { min: 0 },
                }}
              />
            )}
          </Field>
        </Grid>
        <Grid
          item
          xs={3}>
          <Field
            name="details.effectiveStartDate"
            validate={validators.restrictPastDate}>
            {({ input: { name, value, onChange }, meta: { error } }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disablePast
                  required
                  name={name}
                  onChange={(d) => {
                    onChange(
                      dayjs(d).format(DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT),
                    );
                    setValue(
                      'details.effectiveEndDate',
                      dayjs(d)
                        .add(1, 'day')
                        .format(DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT),
                    );
                  }}
                  label="Effective Start Date (YYYY-MM-DD)"
                  format={DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT}
                  value={value ? dayjs(value) : null}
                  slotProps={{
                    field: { fullWidth: true },
                    textField: {
                      helperText: error,
                      error: !!error,
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          </Field>
        </Grid>
        <Grid
          item
          xs={3}>
          <Field
            name="details.effectiveEndDate"
            validate={validators.effectivityEndDateGreaterThanStartDate}>
            {({ input: { name, value, onChange }, meta: { error } }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  required
                  name={name}
                  onChange={(d) =>
                    onChange(
                      dayjs(d).format(DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT),
                    )
                  }
                  label="Effective End Date (YYYY-MM-DD)"
                  format={DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT}
                  value={value ? dayjs(value) : null}
                  minDate={
                    values?.details?.effectiveStartDate
                      ? dayjs(values?.details?.effectiveStartDate).add(1, 'day')
                      : null
                  }
                  slotProps={{
                    field: { fullWidth: true },
                    textField: {
                      helperText: error,
                      error: !!error,
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          </Field>
        </Grid>
      </Grid>
    </Box>
  );
}
